export default __webpack_public_path__ + "static/media/section2_2.4511f0ca.png";